import { render, staticRenderFns } from "./cost-coefficients-table.vue?vue&type=template&id=c107ce68&scoped=true"
import script from "./cost-coefficients-table.vue?vue&type=script&lang=ts"
export * from "./cost-coefficients-table.vue?vue&type=script&lang=ts"
import style0 from "./cost-coefficients-table.vue?vue&type=style&index=0&id=c107ce68&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c107ce68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c107ce68')) {
      api.createRecord('c107ce68', component.options)
    } else {
      api.reload('c107ce68', component.options)
    }
    module.hot.accept("./cost-coefficients-table.vue?vue&type=template&id=c107ce68&scoped=true", function () {
      api.rerender('c107ce68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtc-step/cost-coefficients/cost-coefficients-table.vue"
export default component.exports